<template>
  <div class="header-cb" v-if="!$route.query.view">
    <div>
      <p><b style="font-size:28px; font-weight: 800;">Billing</b></p>
      <p style="margin-left: 25px; font-size: 16px; color: #666; margin-top: 8px;">請求・プラン</p>
    </div>
    <div>
      <a class="button is-primary" href="?view=plan">プランを見る</a>
    </div>
  </div>
  <div class="header-cb" v-else-if="$route.query.view">
    <div>
      <p><b style="font-size:28px; font-weight: 800;">Plan</b></p>
      <p style="margin-left: 25px; font-size: 16px; color: #666; margin-top: 8px;">プラン</p>
    </div>
    <div>
      <a class="button is-primary"
        href="/client/setting/billing"
        v-if="user.billing === 3">
        請求を見る
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      require: true
    }
  },
}
</script>

<style lang="scss" scoped>
.header-cb {
  margin: 10px 20px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-cb > div {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/Billing/BillingHeader.vue